/* ─── Base ─── */

.root {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: 2.75rem;
  padding-inline: var(--space-4);
  border: none;
  border-radius: var(--shape-sm);
  font-family: var(--font-sans);
  font-weight: 600;
  color: var(--md-on-surface-variant);
  background: var(--md-surface-container);
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  box-sizing: border-box;
  text-decoration: none;
  white-space: nowrap;
  transition: background var(--motion-duration-short3)
    var(--motion-easing-standard);
}

/* ─── Interactive (button) affordances ─── */

button.root {
  cursor: pointer;
}

button.root::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  button.root:hover::before {
    opacity: var(--state-hover);
  }
}

button.root:focus-visible::before {
  opacity: var(--state-focus);
}

button.root:active::before {
  opacity: var(--state-pressed);
}

/* ─── Disabled ─── */

button.root:disabled {
  cursor: not-allowed;
  opacity: 0.38;
}

button.root:disabled::before {
  display: none;
}

/* ─── Sizes ─── */

.sm {
  font: var(--type-label-md);
  letter-spacing: var(--tracking-label-md);
  height: 2rem;
  padding-inline: var(--space-3);
  gap: 0.375rem;
}

/* ─── Variants ─── */

.assist {
  /* Default outlined style */
}

.filter {
  /* Default outlined style; selected state below */
}

.input {
  /* Default outlined style; has trailing delete */
}

.suggestion {
  /* Default outlined style */
}

/* ─── Selected state (filter chips) ─── */

.selected {
  background: var(--md-secondary-container);
  color: var(--md-on-secondary-container);
}

/* ─── Leading visual ─── */

.avatar {
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 50%;
  object-fit: cover;
  margin-inline-start: -0.25rem;
}

.leading {
  display: inline-flex;
  font-size: var(--icon-size-sm);
  margin-inline-start: -0.25rem;
}

/* ─── Delete button (input chips) ─── */

.deleteBtn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.125rem;
  height: 1.125rem;
  margin-inline-end: -0.25rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: var(--md-on-surface-variant);
  cursor: pointer;
  font-size: var(--icon-size-xs);
}

.deleteBtn::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: currentColor;
  opacity: 0;
  transition: opacity var(--motion-duration-short3);
  pointer-events: none;
}

@media (hover: hover) {
  .deleteBtn:hover::before {
    opacity: var(--state-hover);
  }
}

.deleteBtn:focus-visible::before {
  opacity: var(--state-focus);
}

.deleteBtn:active::before {
  opacity: var(--state-pressed);
}
